<template>
  <div class="box9">
    <pageTitle
      title="10大项目实战<br/>AI技术直接落地为工作能力"
      text="真实业务场景全流程实战，学完即能落地，<br/>打造企业级AI开发能力"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="highlights">
      <div
        class="highlights__item"
        v-for="(item, index) in highlightList"
        :key="index"
      >
        <p class="highlights__title">{{ item.title }}</p>
        <p class="highlights__desc">{{ item.desc }}</p>
      </div>
    </div>

    <div class="project-panel">
      <div class="nav-box" ref="navBox">
        <div
          class="nav"
          v-for="(item, index) in projectList"
          :key="index"
          :class="{ 'nav--active': cur === index }"
          @click="changeCur(index)"
        >
          {{ item.tab }}
        </div>
      </div>

      <div @click="showPop">
        <swiper :options="swiperOption" ref="mySwiper" class="project-swiper">
          <swiper-slide
            class="project-slide"
            v-for="(item, index) in projectList"
            :key="index"
          >
            <div class="project-card">
              <h3 class="project-card__title">{{ item.title }}</h3>

              <div class="project-card__intro-row">
                <img
                  class="project-card__intro-icon"
                  src="../../../assets/coursePage/llm/box9/icon-intro.png"
                  alt=""
                />
                <span class="project-card__intro-label">项目介绍</span>
              </div>

              <p class="project-card__desc">{{ item.desc }}</p>

              <img
                class="project-card__preview"
                :src="item.img"
                alt=""
              />

              <div class="project-card__btn">查看全部</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="popup">
        <div class="popup__header">
          <div class="popup__title">{{ projectList[cur].title }}</div>
          <div class="popup__close" @click="show = false"></div>
        </div>
        <div class="popup__body">
          <div class="popup__tag">
            <span class="popup__tag-bg"></span>
            项目介绍
          </div>
          <p class="popup__intro">{{ projectList[cur].desc }}</p>

          <div class="popup__tag">
            <span class="popup__tag-bg"></span>
            技术标签
          </div>
          <div class="popup__content">
            <p
              class="popup__point"
              v-for="(point, index) in projectList[cur].lightPoint"
              :key="'light-' + index"
            >
              {{ point }}
            </p>
          </div>

          <div class="popup__tag popup__tag--solution">
            <span class="popup__tag-bg"></span>
            核心业务实现
          </div>
          <div class="popup__content">
            <p
              class="popup__solution-item"
              v-for="(solution, index) in projectList[cur].solution"
              :key="'solution-' + index"
            >
              {{ solution }}
            </p>
          </div>

          <div class="popup__tag popup__tag--solution">
            <span class="popup__tag-bg"></span>
            学完能做
          </div>
          <div class="popup__content">
            <p
              class="popup__point-item"
              v-for="(outcome, index) in projectList[cur].learnOutcome"
              :key="'outcome-' + index"
            >
              {{ outcome }}
            </p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    const that = this;
    return {
      show: false,
      cur: 0,
      highlightList: [
        { title: "行业广", desc: "就业面更广" },
        { title: "项目多", desc: "经验丰富" },
        { title: "项目真", desc: "快速上手" },
      ],
      projectList: [
        {
          tab: "项目一",
          title: "Coze智能面试助手",
          img: require("../../../assets/coursePage/llm/box9/project-1.png"),
          desc:
            "基于Coze平台，结合 LLM/ASR/TTS/RAG技术，打造面试全流程智能辅助系统，实现简历优化、面试录音分析、定制试题生成与实时语音模拟面试",
          lightPoint: ["Coze基础、Coze使用进阶、知识库、数据库"],
          solution: [
            "运用大模型 + 提示词工程实现简历优化、面试分析与内容生成",
            "基于 Coze 平台快速构建智能体，实现面试全流程自动化处理",
            "对接外部知识库与数据库，实现面试题的精准匹配与智能推荐",
            "集成 ASR/TTS 技术，开发支持实时语音交互的模拟面试系统",
            "通过工作流编排实现多模块协同，完成从简历到面试的端到端智能服务",
          ],
          learnOutcome: [
            "掌握 Coze 智能体开发范式，可独立完成多场景智能体应用构建与部署，实现工作流自动化与业务赋能。",
          ],
        },
        {
          tab: "项目二",
          title: "蜂窝头条文本分类",
          img: require("../../../assets/coursePage/llm/box9/project-2.png"),
          desc:
            "本项目是结合今日头条真实场景下的海量数据，快速搭建随机森林和FastText的基线模型，以验证商业化落地的可行性",
          lightPoint: [
            "随机森林、基线模型、BERT优化、模型量化、知识蒸馏、大模型文本分类",
          ],
          solution: [
            "基于业务留存数据，构建快速文本分类系统与短文本精准分类模型",
            "搭建随机森林、FastText 基线模型，验证业务落地能力",
            "基于 BERT 迁移学习，构建并优化文本分类模型",
            "实现神经网络量化、剪枝、知识蒸馏等压缩优化与测试",
            "主流预训练模型深度剖析，拓展 BERT 在生成任务与工程优化的应用",
          ],
          learnOutcome: [
            "学员能够掌握商业化文本分类任务的模型选型、优化技巧及多阶段迭代方法，具备处理高并发数据分类需求的实战能力。",
          ],
        },
        {
          tab: "项目三",
          title: "EduRAG智慧问答系统",
          img: require("../../../assets/coursePage/llm/box9/project-3.png"),
          desc:
            "基于IT职业教育行业答疑大模型抽取RAG解决方案，通过项目学习完成企业及RAG系统完整流程搭建与测试及优化",
          lightPoint: [
            "RAG系统、多数据库技术、混合检索算法、Query意图识别与改写、企业级工程化开发",
          ],
          solution: [
            "搭建 IT 教育智能答疑知识库，实现自动精准问答",
            "开发企业级 RAG 系统，优化答疑准确率与效率",
            "实现智能查询路由，精准分发用户提问",
            "完成全栈工程化，交付可直接部署的答疑服务",
            "构建多源数据检索体系，支撑业务持续迭代",
          ],
          learnOutcome: [
            "学员能够掌握 RAG 系统架构设计、数据库技术、检索算法及企业级开发实践，完成职业教育智慧问答系统的构建与优化。",
          ],
        },
        {
          tab: "项目四",
          title: "InsightScan智扫通",
          img: require("../../../assets/coursePage/llm/box9/project-4.png"),
          desc:
            "系统基于RAG技术及ReAct框架构建，涵盖产品咨询、使用报告生成与优化建议，通过一个统一的Agent界面，为用户提供高效、准确且个性化的支持",
          lightPoint: ["ReAct框架、Flask框架"],
          solution: [
            "基于 ReAct 框架实现智能对话 Agent",
            "利用 RAG 工具构建本地产品知识库",
            "通过 Prompt Engineering 生成用户使用报告",
            "利用 Flask 框架实现模型后端部署",
            "基于 Streamlit 搭建交互式前端服务",
          ],
          learnOutcome: [
            "掌握 ReAct 智能体开发流程，完成 RAG 工具调用、多维度评估系统搭建及生产级服务部署，构建可迭代优化的 C 端智能客服系统。",
          ],
        },
        {
          tab: "项目五",
          title: "简历推荐系统",
          img: require("../../../assets/coursePage/llm/box9/project-5.png"),
          desc:
            "本项目针对企业招聘中简历筛选效率低、匹配不准的痛点，构建基于向量数据库与大模型的 RAG 系统，实现简历自动解析与智能推荐，提升招聘效率与精准度",
          lightPoint: [
            "文档智能、智能代理、向量化与索引、检索增强生成、配置与 DevOps",
          ],
          solution: [
            "基于 LangChain 实现多格式简历智能解析与结构化提取",
            "搭建 Milvus 混合向量索引，实现多路召回检索",
            "开发异步 RAG 推荐链，生成结构化候选人推荐结果",
            "实现智能 Agent，支持多轮对话式候选人筛选",
            "完成全栈部署，并用 Ragas 进行系统评估优化",
          ],
          learnOutcome: [
            "独立搭建企业级 RAG 智能系统，可用于文档解析、资料检索、智能匹配、行业咨询、办公助手等场景。",
            "学员能够掌握文档智能处理、向量化索引、RAG 系统开发及 Agent 框架应用，完成可扩展的简历推荐系统部署。",
          ],
        },
        {
          tab: "项目六",
          title: "SmartVoyage旅行智能助手",
          img: require("../../../assets/coursePage/llm/box9/project-6.png"),
          desc:
            "SmartVoyage 智能旅行助手系统，使用 A2A (Agent-to-Agent) 协议构建多代理协作框架，支持用户查询天气和票务信息",
          lightPoint: [
            "Python-a2a、LangChain、Streamlit、MySQL Connector、Uvicorn",
          ],
          solution: [
            "搭建基于 Python-a2a 协议的多代理协作框架",
            "用 LangChain+DeepSeek 实现意图识别与动态路由",
            "实现 MCP 工具服务器的标准化 MySQL 查询接口",
            "开发天气 / 票务代理，集成动态 SQL 生成与数据查询",
            "基于 Streamlit 开发多代理实时交互前端客户端",
          ],
          learnOutcome: [
            "掌握 A2A 多代理框架开发、意图识别与数据库查询技能，完成交互式旅行助手系统的构建。",
          ],
        },
        {
          tab: "项目七",
          title: "Agent智能工单",
          img: require("../../../assets/coursePage/llm/box9/project-7.png"),
          desc:
            "本系统结合大模型能力，融合多种AI技术（RAG+多Agent+MCP）等，完成大型企业工单的全流程流转闭环，解决传统客服流程低效问题",
          lightPoint: [
            "Git、LangGraph、PostgreSQL、大模型、Redis、Kafka、Docker",
          ],
          solution: [
            "采用无侵入式架构，实时高效处理业务系统数据",
            "实现企业私有化数据脱敏，保障业务数据安全合规",
            "基于多层模型架构，实现复杂工单的智能分类处理",
            "基于 RAG+MCP 技术，融合知识库与 API 上下文工程",
            "支持动态知识库更新，以及 Docker 企业级容器部署",
          ],
          learnOutcome: [
            "掌握企业级智能工单系统架构设计，实现全流程自动化处理，具备复杂业务场景下多智能体系统的开发与运维能力。",
          ],
        },
        {
          tab: "项目八",
          title: "微博文本信息抽取",
          img: require("../../../assets/coursePage/llm/box9/project-8.png"),
          desc:
            "基于Qwen/DeepSeek+LoRA微调实现微博文本信息抽取+文本分类的多任务，通过一个大模型同时解决多种任务开发和应用",
          lightPoint: [
            "数据预处理、LoRA 微调、P-Tuning 微调、模型训练评估/Flask 部署",
          ],
          solution: [
            "微调 ChatGLM-6B 模型，适配文本抽取与分类业务场景",
            "采用多任务学习，提升模型文本处理效率与综合能力",
            "实现非结构化文本抽取，高效提取实体关系事件信息",
            "构建多任务数据链路，保障模型训练数据适配性",
            "开发 Flask 模型 API，实现大模型能力的服务化落地",
          ],
          learnOutcome: [
            "掌握大模型高效微调与文本处理能力，可独立完成模型训练、评估与 API 部署，快速落地信息抽取与分类业务场景。",
          ],
        },
        {
          tab: "项目九",
          title: "QWen微调文本摘要",
          img: require("../../../assets/coursePage/llm/box9/project-9.png"),
          desc:
            "基于 QWen 模型，结合 DeepSpeed、GPTQ 和 QLoRA 技术，优化训练与推理，部署高效文本摘要系统于 vLLM 平台",
          lightPoint: [
            "数据集处理、模型构建、模型训练、模型预测、大模型并行计算、大模型量化、模型部署和推理优化框架",
          ],
          solution: [
            "数据集处理、模型构建、模型训练、模型预测",
            "大模型并行计算：deepspeed、数据并行、流水线并行、模型并行",
            "大模型量化：训练量化方法QLora，训练后量化方法GPTQ",
            "模型部署和推理优化框架：vLLM和Ollama",
          ],
          learnOutcome: [
            "学员能够掌握 QLoRA 量化微调与并行计算技术，完成文本摘要模型的高效训练与部署。",
          ],
        },
        {
          tab: "项目十",
          title: "中医药知识图谱",
          img: require("../../../assets/coursePage/llm/box9/project-10.png"),
          desc:
            "“草本通”项目致力于解决中医药知识难以理解、碎片化严重、检索效率低等问题，打造一个可理解、可对话、可传播、可拓展的智能知识服务平台",
          lightPoint: ["Neo4j、LangGraph、Streamlit"],
          solution: [
            "实现多源中医药数据爬取与预处理，适配知识图谱构建",
            "基于 Neo4j+FAISS 构建中医药知识图谱，实现 RAG 检索增强",
            "通过 LangGraph 实现智能问答与多意图工作流编排",
            "基于 FastAPI 实现 LangGraph 智能体流式 API 接口开发",
            "基于 LlamaFactory 微调大模型，实现实体关系自动生成",
          ],
          learnOutcome: [
            "学员能够掌握知识图谱构建、多智能体流程调度及生成式应用开发，具备垂直领域知识智能化平台的搭建能力。",
          ],
        },
      ],
      swiperOption: {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 18,
        centeredSlides: true,
        initialSlide: 0,
        on: {
          slideChangeTransitionStart() {
            that.cur = this.realIndex;
            const navBox = that.$refs.navBox;
            if (navBox) {
              navBox.scrollLeft = this.realIndex * 75;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    showPop() {
      this.show = true;
    },
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import './variables.less';

.box9 {
  position: relative;
  padding: 80px 0 ;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box9/bg.png") no-repeat top
    center;
  background-size: 100% 100%;
  background-color: #f3f6ff;
  overflow: hidden;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
    padding: 0 32px;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 40px;
    margin-top: 14px;
  }

  .highlights {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    margin: 48px 24px 0;
  

    &__item {
      position: relative;
      flex: 1;
      text-align: center;

      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        width: 2px;
        height: 74px;
        transform: translateY(-50%);
        background: linear-gradient(180deg, rgb(237, 237, 245), rgb(197, 197, 255), rgba(213, 213, 232, 0))
      }
    }

    &__title {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 32px;
      font-weight: 700;
      line-height: 40px;
      .llm-text-gradient();
    }

    &__desc {
      margin: 4px 0 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #072557;
      line-height: 40px;
    }
  }

  .project-panel {
    position: relative;
    z-index: 1;
    margin-top: 48px;
  }

  .nav-box {
    display: flex;
    padding: 0 32px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .nav {
    flex-shrink: 0;
    min-width: 138px;
    height: 68px;
    margin-right: 20px;
    padding: 0 24px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #ffffff;
    font-family: PingFangSC, PingFang SC;
    font-size: 26px;
    font-weight: 400;
    color: #4e5969;
    line-height: 68px;
    text-align: center;
    transition: all 0.2s;

    &--active {
      background: url("../../../assets/coursePage/llm/box9/tab-active.png")
        no-repeat center;
      background-size: 100% 100%;
      font-weight: 600;
      color: #ffffff;
    }
  }

  .project-slide {
    width: 686px;
  }

  .project-card {
    position: relative;
    margin: 32px 0 0;
    padding: 32px 36px 36px;
    box-sizing: border-box;
  
    background: url("../../../assets/coursePage/llm/box9/card-bg.png")
      no-repeat center;
    background-size: 100% 100%;

    &__title {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 36px;
      font-weight: 700;
      color: #072557;
      line-height: 52px;
    }

    &__intro-row {
      display: flex;
      align-items: center;
      margin-top: 16px;
    }

    &__intro-icon {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }

    &__intro-label {
      margin-left: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 700;
      color: #072557;
      line-height: 40px;
    }

    &__desc {
      margin: 8px 0 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #6e7f94;
      line-height: 36px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    &__preview {
      display: block;
      width: 100%;
      height: 340px;
      margin-top: 24px;
      border-radius: 16px;
      object-fit: cover;
    }

    &__btn {
      width: 180px;
      height: 56px;
      margin: 32px auto 0;
      border-radius: 32px;
      background: linear-gradient(224deg, #2483fa 0%, #755bfe 100%);
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
    }
  }

  .van-popup {
    max-height: calc(100vh - 80px);
    padding-bottom: 24px;
    box-sizing: border-box;
  }

  .popup {
    padding: 0 0 24px;
    box-sizing: border-box;

    &__header {
      position: sticky;
      top: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 132px;
      padding: 16px 48px 0;
      background: #ffffff;
      box-sizing: border-box;
    }

    &__title {
      font-family: PingFangSC, PingFang SC;
      font-size: 36px;
      font-weight: 600;
      color: #1d2129;
      line-height: 48px;
    }

    &__close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat
        center;
      background-size: cover;
    }

    &__body {
      max-height: 900px;
      overflow-y: auto;
      padding:0 48px;
      -webkit-overflow-scrolling: touch;
    }

    &__intro {
      margin: 0 0 40px;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }

    &__tag {
      position: relative;
      display: inline-block;
      margin-bottom: 24px;
      padding: 0 24px;
      height: 56px;
      border-radius: 0 32px 32px 24px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      .llm-text-gradient();
      line-height: 56px;

      &-bg {
        position: absolute;
        inset: 0;
        z-index: -1;
        border-radius: inherit;
        background: linear-gradient(129deg, #f0f0ff 0%, #dbe3ff 100%);
      }

      &--solution {
        text-align: center;
      }
    }

    &__content {
      margin-bottom: 40px;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      p {
        margin: 0;
      }
    }

    &__point {
      display: block;
    }

    &__solution-item {
      display: block;
      position: relative;
      padding-left: 24px;
      &::before {
        content: "·";
        position: absolute;
        left: 0;
        top: 0;
        font-size: 54px;
        line-height: 44px;
        color: #4e5969;
      }
    }
  }
}
</style>
